import {Controller, useForm} from "react-hook-form"
import {FormErrorBox} from "common/FormErrorBox"
import React, {useEffect} from "react"
import ReactDatePicker from "react-datepicker"
import {NoneOperationComment} from "dto/realdevice/none-operation-comment"
import dayjs from "dayjs"

export type CommentInput = {
    comment: string,
    fromDate: Date,
    endDate: Date,
}
export const NoneOperationCommentForm = ({onSubmit, onCancel, comment}: {onSubmit: (data: CommentInput) => void, onCancel: () => void, comment?: NoneOperationComment | null | undefined}) => {
    const {register, handleSubmit, control, formState: {errors}, setValue, getValues, watch} = useForm<CommentInput>()
    useEffect(() => {
       if(comment) {
           setValue("comment", comment.comment)
           setValue("fromDate", dayjs(comment.fromDate).toDate())
           setValue("endDate", dayjs(comment.endDate).toDate())
       }
    }, [comment])
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="pd5 m-5 panel">
                <header className={`panel-heading`}>
                    <p className="modal-card-title">미운행 사유입력</p>
                </header>
                <div className="columns mb0 panel-block mt">
                    <div className="column columns">
                        <div className=" stitlebox label">미운행 시작/종료일</div>
                        <div className="column mt10">
                            <Controller
                                name="fromDate" control={control} defaultValue={new Date()}
                                render={({field}) => (
                                    <ReactDatePicker
                                        className="w100 is-clickable"
                                        locale="ko"
                                        dateFormat="yyyy/MM/dd"
                                        selected={field.value}
                                        onChange={(date) => {
                                            field.onChange(date)
                                        }}
                                        placeholderText="미운행 시작일"
                                    />
                                )}
                            />
                            <FormErrorBox error={errors.fromDate}/>
                        </div>
                        <div className="column mt10">
                            <Controller
                                name="endDate" control={control} defaultValue={new Date()}
                                render={({field}) => (
                                    <ReactDatePicker
                                        className="w100 is-clickable"
                                        locale="ko"
                                        dateFormat="yyyy/MM/dd"
                                        selected={field.value}
                                        onChange={(date) => {
                                            field.onChange(date)
                                        }}
                                        placeholderText="미운행 종료일"
                                    />
                                )}
                            />
                            <FormErrorBox error={errors.fromDate}/>
                        </div>

                    </div>
                </div>
                <div className="columns mb0 panel-block">
                    <div className="column columns">
                        <div className=" stitlebox label">사유 입력</div>
                        <div className="column">
                            <textarea
                                rows={5}
                                {...register("comment", {required: true})}
                                className="textarea" placeholder="사유"/>
                            <FormErrorBox error={errors.comment}/>
                        </div>
                    </div>
                </div>
                <div className="panel-block is-flex is-flex-direction-row-reverse">
                    <button className="button is-light" onClick={(evt) => {
                        evt.preventDefault()
                        evt.stopPropagation()
                        onCancel()
                    }}>취소</button>
                    <button className="button is-success mr5">저장</button>
                </div>
            </div>
        </form>
    )
}

const RequiredMark = () => {
    return (
        <span style={{color: "red"}}>*</span>
    )
}